import {assetsVersion} from './_assets_version.js';

export const urlCacheBuster = (url) => {
  url = url.replace(/\?.*$/, '');
  return `${url}?ver=${assetsVersion()}`;
}
